import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useValidatorStore } from '@features/proxy';
import { pageRedirects, useLoginStore } from '@features/shared';
import { authAPI } from '@features/shared';

export const ValidateConsent = () => {
  const [searchParams] = useSearchParams();

  const { currentUser } = useLoginStore();
  const { setValidateStep } = useValidatorStore();

  const validateConsent = useCallback(async () => {
    const channel = searchParams.get('channel') || 'btp';
    const spName = searchParams.get('spName');
    const samlContext = searchParams.get('samlContext');
    const isRequiredUpdateConsent = await authAPI.consentVersionCheck({
      uid: currentUser.uid ?? '',
      channel: channel,
    });

    if (isRequiredUpdateConsent === 'Y')
      return pageRedirects.consentUpdate({
        uid: currentUser.uid ?? '',
        uidSignature: currentUser.uidSignature ?? '',
        signatureTimestamp: currentUser.signatureTimestamp,
        spName: spName ?? '',
        samlContext: samlContext ?? '',
        channel: channel,
      });

    return setValidateStep('record-last-login');
  }, [searchParams, currentUser.uid, currentUser.uidSignature, currentUser.signatureTimestamp, setValidateStep]);

  useEffect(() => {
    validateConsent();
  }, [validateConsent]);

  return null;
};
